import { Typography } from '@cp/ds/src/components/typography';
import { FC } from 'react';

export interface FeedbackAuthorNameProps {
  authorName?: string;
}

export const FeedbackViewAuthorName: FC<FeedbackAuthorNameProps> = ({ authorName }) => (
  <Typography component="div" variant="body bold">
    {authorName}
  </Typography>
);
